import { FC } from "react";
import { CoverageWidgetHighChartView } from "./CoverageWidgetHighChartView";
import { useAppSelector } from "@/store/hooks";
import { coverageWidgetByWidgetIdGroupsSelector } from "@/store/dashboards/selectors/widgets/coverage/widget-view/coverageWidgetByWidgetIdGroupsSelector";
import { coverageWidgetHasAggregationSelector } from "@/store/dashboards/selectors/widgets/coverage/widget-view/coverageWidgetHasAggregationSelector";
import { coverageWidgetVisualizationSelector } from "@/store/dashboards/selectors/widgets/coverage/widget-view/coverageWidgetVisualizationSelector";

interface CoverageWidgetContentChartViewProps {
  widgetId: string;
}

export const CoverageWidgetContentChartView: FC<
  CoverageWidgetContentChartViewProps
> = ({ widgetId }) => {
  const groups = useAppSelector((state) =>
    coverageWidgetByWidgetIdGroupsSelector(state, widgetId),
  );
  const hasAggregations = useAppSelector((state) =>
    coverageWidgetHasAggregationSelector(state, widgetId),
  );
  const visualization = useAppSelector((state) =>
    coverageWidgetVisualizationSelector(state, widgetId),
  );

  if (!visualization) {
    return;
  }

  return (
    <CoverageWidgetHighChartView
      data={groups}
      visualization={visualization}
      hasAggregations={hasAggregations}
    />
  );
};
